<template>
  <v-dialog v-model="dialog">
    <template #activator="{on}">
        <slot name="activator" :on="on" :loading="loading">
            <v-btn :loading="loading" v-on="on">View invoice</v-btn>
        </slot>
    </template>
    <v-card v-if="model">
        <v-toolbar elevation="0">
            Invoice # {{ model.invoiceNumber }}
            <v-spacer />
            <div>
                <span class="mr-4">Status</span>
                <InvoiceStatusChip :status="model.statusId" />
            </div>
            <v-spacer />
            <v-btn :href="model.billingUrl" target="_blank" class="mr-4">
              <v-icon left>mdi-arrow-up</v-icon>Open on billing.domagolf.com
            </v-btn>
            <InvoicePrint :invoice="model" />
        </v-toolbar>
        <v-card-text v-if="model.rows">
            <v-row>
                <v-col>
                    <v-data-table
                        v-if="model.rows.length > 0"
                        :items="model.rows"
                        :headers="rowHeaders"
                    >
                        <template #[`item.type`]="{ item }">
                            {{ item.type.toUpperCase() }}
                        </template>

                        <template #[`item.unit_price`]="{ item }">
                            {{ item.unit_price | currency(item.currency)}}
                        </template>

                        <template #[`item.amount`]="{ item }">
                            {{ item.amount | currency(item.currency)}}
                        </template>

                        <template #[`item.tax`]="{ item }">
                            {{ item.tax | currency(item.currency)}}
                        </template>

                        <template #[`item.discount_in_percent`]="{ item }">
                            {{ item.discount_in_percent ? item.discount_in_percent : '-' }}
                        </template>

                        <template #foot>
                            <tfoot v-if="model">
                                <tr class="">
                                    <td colspan="3">Total</td>
                                    <td>{{ totalQuantity }}</td>
                                    <td>{{ totalAmount | currency(model.currency) }}</td>
                                    <td>{{ totalTax | currency(model.currency) }}</td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </template>
                    </v-data-table>
                    <v-alert v-else type="info">
                        No details available, please refer to order for details
                    </v-alert>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InvoicePrint from './InvoicePrint.vue';
import InvoiceStatusChip from './InvoiceStatusChip.vue'
export default {
    props: {
        invoice: {
            type: Object,
            default: () => null
        },
        invoiceId: {
            type: Number,
            default: () => null
        }
    },
    data: () => ({
        fetchInvoice: {},
        dialog: false,
        rowHeaders: [
            { text: "Type", value: "type" },
            { text: "Text", value: "text" },
            { text: "Unit Price", value: "unit_price" },
            { text: "Quantity", value: "quantity" },
            { text: "Amount", value: "amount" },
            { text: "Tax", value: "tax" },
            { text: "Discount", value: "discount_in_percent" },
        ]
    }),
    computed: {
        ...mapGetters("invoices", ["loading"]),
        model() {
            return this.invoice ? this.invoice : this.fetchInvoice;
        },
        totalQuantity () {
            return this.model.rows.reduce((total, row) => total + row.quantity, 0)
        },
        totalAmount () {
            return this.model.rows.reduce((total, row) => total + row.amount, 0)
        },
        totalTax () {
            return this.model.rows.reduce((total, row) => total + row.tax, 0)
        }
    },
    mounted() {
        if (!this.invoice && this.invoiceId) {
            this.getInvoiceById(this.invoiceId)
                .then(({ invoice }) => {
                this.fetchInvoice = invoice;
            });
        }
    },
    methods: {
        ...mapActions("invoices", { getInvoiceById: "getById" })
    },
    components: { InvoiceStatusChip, InvoicePrint }
}
</script>

<style>

</style>